exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-19d4b68a]{float:left;border:1px solid #dbdbdb;background-color:#f5f5f5;margin:5px;cursor:pointer;display:flex}.image img[data-v-19d4b68a]{margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/tmp/build_919341db/resources/nuxt/assets","/static":"/tmp/build_919341db/resources/nuxt/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19d4b68a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/nuxt/pages/office/reclamations/_id.vue
// module id = ZCwU
// module chunks = 2